const terminals = {
  namespaced: true,
  state: {
    terminals: [],
  },
  getters: {
    getTerminalChanges(state) {
      let terminals = state.terminals.filter((terminal) => !terminal.status || terminal.status === "100");
      return terminals || [];
    },
  },
  mutations: {
    GET_TERMINALS: (state, payload) => {
      state.terminals = payload.data.terminalList;
    },
  },
  actions: {
    getTerminals({ commit, rootState }) {
      rootState.axios
        .get("/api/getTerminalList")
        .then((response) => {
          commit("GET_TERMINALS", response);
        })
        .catch((error) => console.log("error ", error));
    },
    getTerminalFromId({ state }, terminalId) {
      const terminal = state.terminals.find(({ _id }) => _id === terminalId);
      return terminal;
    },
  },
};

export default terminals